import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from './base-endpoint-service';
import {ListItem} from '../../entities/list-item.entity';
import Diagnosis = Backend.App.Resources.Dashboard.Administration.Diagnosis;
import DiagnosisData = Backend.App.Data.Dashboard.Administration.DiagnosisData;

@Injectable({providedIn: 'root'})
export class DiagnosisService extends BaseEndpointService<Diagnosis, DiagnosisData> {
  protected override endpoint = '/administration/diagnoses';

  public override modelToMultiSelectItem(m: Diagnosis): ListItem & { model: Diagnosis; } {
    return {
      id: m.id,
      text: m.title.de ?? '',
      isDisabled: false,
      model: m,
    }
  }
}
